import React from 'react';
import { cn } from '../../utils';
import styles from './ChatWindowContainer.module.css';

export interface ChatWindowContainerProps {
  id?: string;
  width?: number | string;
  height?: number | string;
  minWidth?: string;
  minHeight?: string;
  maxWidth?: string | number;
  maxHeight?: string | number;
  backgroundColor?: string;
  textColor?: string;
  borderColor?: string;
  className?: string;
  style?: React.CSSProperties;
  children: React.ReactNode;
}

export function ChatWindowContainer({
  id = 'kapia-chat-window',
  width,
  height,
  minWidth = '320px',
  minHeight = '400px',
  maxWidth,
  maxHeight,
  backgroundColor = '#fcfcfc',
  textColor = '#1e293b',
  borderColor,
  className,
  style,
  children,
}: ChatWindowContainerProps) {
  const computedStyle: React.CSSProperties = {
    width: width ? (typeof width === 'number' ? `${width}px` : width) : undefined,
    height: height ? (typeof height === 'number' ? `${height}px` : height) : undefined,
    minWidth,
    minHeight,
    maxWidth: maxWidth
      ? typeof maxWidth === 'number'
        ? `${maxWidth}px`
        : maxWidth
      : 'none',
    maxHeight: maxHeight
      ? typeof maxHeight === 'number'
        ? `${maxHeight}px`
        : maxHeight
      : 'none',
    backgroundColor,
    color: textColor,
    borderColor: borderColor || undefined,
    ...style,
  };

  return (
    <div
      {...(id && { id })}
      className={cn(styles.container, className)}
      style={computedStyle}
    >
      {children}
    </div>
  );
}
